import { Observable } from '../utils/Observable';

export interface SelectionState {
  activeBranchId: string | null;
  hoveredPersonId: string | null;
  generationCap: number;
}

const INITIAL_SELECTION_STATE: SelectionState = {
  activeBranchId: null,
  hoveredPersonId: null,
  generationCap: 10,
};

export const SelectionStore = new Observable<SelectionState>(INITIAL_SELECTION_STATE);
